import {isEmpty} from "../utils/commons";
import {submitRegistration} from "../apis/security_apis";

export const REGISTER = "register";
export const REGISTER_ON_CHANGE = "registerOnChange";
export const REGISTER_ON_VALIDATE = "registerOnValidate";
const REGISTER_SUBMITTING = "registerSubmitting";
const REGISTER_SUBMITTED = "registerSubmitted";
export const REGISTER_RESET = "registerReset";


const initErrors = () => ({
    email: "",
    password: "",
    firstName: "",
    lastName: "",
})

const initState = () => ({
    email: "",
    firstName: "",
    lastName: "",
    error: "",
    submitting: false,
    info:"",
    fieldErrors: initErrors(),
})

const state = initState();

const mutations = {
    [REGISTER_ON_CHANGE] (state, payload) {
        Object.assign(state, {[payload.name]:payload.value});
    },
    [REGISTER_ON_VALIDATE] (state, payload) {
        Object.assign(state, {fieldErrors: {...payload}});
    },
    [REGISTER_SUBMITTING] (state) {
        Object.assign(state, {submitting: true, error: ""});
    },
    [REGISTER_SUBMITTED] (state, payload) {
        Object.assign(state, {submitting: false, error: payload.error, info: payload.info});
    },
    [REGISTER_RESET] (state) {
        Object.assign(state, initState())
    }
}

const actions = {
    [REGISTER_ON_CHANGE] ({commit}, payload) {
        commit(REGISTER_ON_CHANGE, payload)
    },
    [REGISTER_RESET] ({commit}, payload) {
        commit(REGISTER_RESET, payload)
    },
    [REGISTER_ON_VALIDATE] ({commit, state}) {
        let errors = {};
        ["email", "password", "firstName", "lastName"].forEach( key => {

            if(isEmpty(state[key])) {
                errors[key] = "This field is required";
            }

        });

        commit(REGISTER_ON_VALIDATE, errors);
        if(Object.keys(errors).length > 0) {
            commit(REGISTER_ON_CHANGE, {name: "error", value: "Some fields invalid"});
        }else {
            commit(REGISTER_ON_CHANGE, {name: "error", value: ""});
        }
    },
    [REGISTER] ({commit, state}, callback) {

        commit(REGISTER_SUBMITTING);
        submitRegistration({email: state.email, password: state.password, firstName: state.firstName, lastName: state.lastName})
            .then((results) => {
                    let info = !results.error? "User registration successful" : "";
                    commit(REGISTER_SUBMITTED, {info, error: results.error})
                    callback();
                },
                (results) => {
                    let error = !results.error? "Registration failed.": results.error;
                    commit(REGISTER_SUBMITTED, {info: "", "error": error});
                    callback();
                })


    }
}


export default {
    state,
    mutations,
    actions
}
